import React from 'react';

import { Flex } from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';

import { CloseCircle, CheckCircle } from 'assets/assetsV1/iconComponents';

import { sendRespondedToFeedbackRequest } from 'constants/mixpanelHelper';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { acceptFeedback, declineFeedback } from 'services/continuousFeedback';

import { Button } from 'uiToolkitV1/Button';

const AcceptDenyButtonGroup = ({ feedbackId, peerStatus, forceUpdate = () => {}, source, ...props }) => {
  const queryClient = useQueryClient();

  const handleAccept = async (e) => {
    e?.stopPropagation();
    try {
      const res = await acceptFeedback({ feedbackId });
      sendRespondedToFeedbackRequest({
        eventProperties: {
          response: 'Accept',
          // source
        },
      });
      queryClient.invalidateQueries({ queryKey: ['CFTable'] });
      queryClient.invalidateQueries({ queryKey: ['CFTabs'] });
      queryClient.invalidateQueries({ queryKey: [REACT_QUERY_KEYS.mySummary.mySummaryFeedback] });
    } catch (err) {
      console.error('Error accepting : ', err);
    }
  };

  const handleReject = async (e) => {
    e?.stopPropagation();
    try {
      const res = await declineFeedback({ feedbackId });
      sendRespondedToFeedbackRequest({
        eventProperties: {
          response: 'Reject',
          // source
        },
      });
      queryClient.invalidateQueries({ queryKey: ['CFTable'] });
      queryClient.invalidateQueries({ queryKey: ['CFTabs'] });
      queryClient.invalidateQueries({ queryKey: [REACT_QUERY_KEYS.mySummary.mySummaryFeedback] });
    } catch (err) {
      console.error('Error rejecting : ', err);
    }
  };

  return (
    <Flex
      sx={{
        '.chakra-button': {
          padding: '4px',
        },
        '.chakra-text': { margin: 0 },
      }}
      {...props}
    >
      <Button variant="rowButtonOutlined" mr="20px" StartIcon={CheckCircle} onClick={handleAccept}>
        Accept
      </Button>
      <Button variant="rowButtonOutlined" StartIcon={CloseCircle} color="red" onClick={handleReject} mr="8px">
        Deny
      </Button>
    </Flex>
  );
};

export { AcceptDenyButtonGroup };
